import React from 'react'

import logoCampana from './../../../assets/images/logoCampana.png'
import elPoder from './../../../assets/images/elPoder.png'
import background from '../../../assets/images/homePoligon.svg'
import './poligon-logo.scss'
const PoligonLogo = ({ className = '' }) => {
  return (
    <div className={'f-poligon-logo ' + className}>
      <div className="f-poligon-logo__background">
        <img src={background} />
      </div>
      <img
        className="f-poligon-logo__campana"
        src={logoCampana}
        alt="campana logo"
      />
      <h3 className="f-poligon-logo__text">
        Nosotras queremos acompañarte <br />
        a encontrar un mundo de confianza, <br />
        para que aprendas sobre tu cuerpo <br />y <b>¡eliminemos tabúes!</b>
      </h3>
      <img
        className="f-poligon-logo__middleimg"
        src={elPoder}
        alt="Logo de actividad"
      />
      <h3 className="f-poligon-logo__text2">
        ¡Poner a prueba <br /> <b>tu memoria!</b>
      </h3>
    </div>
  )
}

export default PoligonLogo
